import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import createTrigger from '@/API/Triggers/createTrigger';
import { toast } from 'react-toastify';

const useCreateTrigger = (
    formData,
    isAddMode,
    resetToMainTable,
    isCopy,
    setSelectedTriggerId,
    switchMode,
) => {
    const { currentScope } = useSelector((state) => state.login);
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async () => {
            try {
                const data = await createTrigger(formData, currentScope).then(
                    (res) => {
                        if (!isCopy) {
                            toast.success('Trigger created successfully');
                            resetToMainTable();
                        } else {
                            toast.success('Trigger copied successfully');
                            setSelectedTriggerId(res?.id);
                            queryClient.invalidateQueries(['trigger', res?.id]);

                            switchMode('Loading');
                            setTimeout(() => {
                                switchMode('Edit');
                            }, 500);
                        }
                        return res;
                    },
                );
                return data;
            } catch (error) {
                const errorMessage = `Failed to create trigger: ${error}`;
                toast.error(errorMessage);
                throw new Error(errorMessage);
            }
        },
        refetchOnWindowFocus: false,
        staleTime: 0,
        enabled: isAddMode || isCopy,
    });
};

export default useCreateTrigger;
